import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "../styles/ContactezNous.css";
import api from '../apiService/api';

// const API_URL = "https://api.kasbah-magic.com/conciergeLastVersion/index.php?action=create_contact";
const API_URL = api.API_URL+ "create_contact";

const ContactezNous = () => {
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: ""
  });

  const [statusMessage, setStatusMessage] = useState("");

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  // Function to handle phone number input
  const handlePhoneInput = (e) => {
    let value = e.target.value;

    if (!value.startsWith("+")) {
      value = "+" + value.replace(/\D/g, ''); 
    } else {
      value = "+" + value.slice(1).replace(/\D/g, '');
    }

    if (value.length > 13) {
      value = value.slice(0, 13);
    }

    setFormData({ ...formData, phone: value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (data.success) {
        setStatusMessage(" " + t("formSuccessMessage"));
        setFormData({ name: "", email: "", phone: "", message: "" });

        // Hide status message after 5 seconds
        setTimeout(() => {
          setStatusMessage("");
        }, 5000);
      } else {
        setStatusMessage("❌ " + (data.message || t("formErrorMessage")));
        
        setTimeout(() => {
          setStatusMessage("");
        }, 5000);
      }
    } catch (error) {
      setStatusMessage("❌ " + t("formErrorMessage"));

      setTimeout(() => {
        setStatusMessage("");
      }, 5000);
      
      console.error("Error submitting contact form:", error);
    }
  };

  return (
    <div className="contact-container">
      <div className="contact-description">
        <h2>{t("contactTitle")}</h2>
        <p>
          {t("contactDescription1")}
          <br />
          {t("contactDescription2")}
        </p>
      </div>

      <form className="contact-form" onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder={t("namePlaceholder")}
          value={formData.name}
          onChange={handleChange}
          required
        />

        <input
          type="email"
          name="email"
          placeholder={t("emailPlaceholder")}
          value={formData.email}
          onChange={handleChange}
          required
          pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
          title={t("emailValidationMessage")}
        />

        <input
          type="tel"
          name="phone"
          placeholder={t("phonePlaceholder")}
          value={formData.phone}
          onChange={handlePhoneInput}
          inputMode="numeric"
          pattern="[\+]{1}[0-9]{1,12}"
          title={t("phoneValidationMessage")}
          required
        />

        <textarea
          name="message"
          placeholder={t("messagePlaceholder")}
          value={formData.message}
          onChange={handleChange}
          required
        ></textarea>

        <button type="submit">{t("submitButtonText")}</button>

        {statusMessage && <p className="status-message">{statusMessage}</p>}
      </form>
    </div>
  );
};

export default ContactezNous;
